<template>
    <div id="app">
        <RouterView v-if="isRouterAlive" />
    </div>
</template>

<script>
export default {
    provide() {
        return {
            reload: this.reload
        }
    },
    data() {
        return {
            isRouterAlive: true
        }
    },
    watch: {
        $route: 'routeChange'
    },
    mounted() {
        // 监听屏幕大小
        window.onresize = () => {
            // window.innerWidth 包括滚动条宽度
            // document.documentElement.offsetWidth 不包括滚动条宽度
            // @media 宽度是包括滚动条的宽度
            this.$store.commit('settings/setMode', document.documentElement.offsetWidth)
        }
        window.onresize()
    },
    methods: {
        // 刷新页面，有两种方式
        // 默认为重载组件，强制把 <RouterView /> 销毁再重建，该方法的弊端在于会清空 keep-alive 的缓存
        // 第二种为跳转页面，会跳转到一个空白页，然后通过 $router.go(-1) 返回当前页，体验欠佳，但能保留 keep-alive 的缓存
        reload(type = 1) {
            if (type == 1) {
                this.isRouterAlive = false
                this.$nextTick(() => (this.isRouterAlive = true))
            } else {
                this.$router.push({
                    name: 'reload'
                })
            }
        },
        routeChange(newVal, oldVal) {
            if ((newVal.name === oldVal.name) || (newVal.name == 'navPoliciesDetails' && oldVal.name == 'PoliciesDetails')) {
                this.reload(2)
            }
        }
    },
    metaInfo: {
        titleTemplate: title => {
            return title
                ? `${title} - ${process.env.VUE_APP_TITLE}`
                : process.env.VUE_APP_TITLE
        }
    }
}
</script>
